import * as React from 'react'
import {Button, ButtonText} from '../ui/button'
import useAppStore from '@/store/useAppStore'
import NonModalWindow from '@/components/NonModalWindow'
import {Cog6ToothIcon, InboxIcon, PlusCircleIcon, XMarkIcon} from '@heroicons/react/16/solid'
import {Switch} from '../ui/switch'
import useEnableModel from '@/services/api/model/useEnableModel'
import useDisableModel from '@/services/api/model/useDisableModel'
import {ChevronLeft} from 'lucide-react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'


export default function ModelsWindow() {
    const toggleNonModalWindow = useAppStore((state) => state.toggleNonModalWindowState)
    // const {mutate: enableModel} = useEnableModel()
    // const {mutate: disableModel} = useDisableModel()

    return (
        <NonModalWindow
            onClose={() => {
                toggleNonModalWindow()
            }}
        >
            <NonModalWindow.Header className="border-none overflow-visible  items-start">
                <div className="flex  ">
                        <Button
                            type="button"
                            iconOnly
                            variant="ghost"
                            size="sm"
                            className="size-7 self-start"
                        >
                            <ChevronLeft />
                        </Button>
                        <div className=' mx-2 p-1'>
                            <div  className='flex flex-1 justify-between mb-1 '>
                                <p className="flex-1 ">
                                    Very Long Name For Models
                                </p>
                                <Switch
                                    checked={true}
                                />
                            </div>
                            <p className="text-xs text-txt-secondary">Affordable home loans with flexible payments</p>

                        </div>
                </div>
                <Button
                    type="button"
                    iconOnly
                    variant="ghost"
                    onClick={() => toggleNonModalWindow()}
                    size="sm"
                    className="size-7 self-start"
                >
                    <XMarkIcon/>
                </Button>
            </NonModalWindow.Header>

            <NonModalWindow.Body className="min-h-[78vh] pt-2">
                <Tabs
                    // key={categoryEntity?.id ? 1 : 0}
                    defaultValue={"transactions"}
                    className=""
                >
                        <TabsList className="mb-4 w-full">
                            <TabsTrigger value="transactions" className="flex gap-1  w-full">
                                <PlusCircleIcon /> <span>Transactions</span>
                            </TabsTrigger>
                            <TabsTrigger value="settings" className="flex gap-1  w-full">
                                <Cog6ToothIcon /> <span>Settings</span>
                            </TabsTrigger>
                        </TabsList>
                    <TabsContent value="transactions" className="">
                        <div className=" flex items-center flex-col pt-8 p-4 text-txt-secondary">
                            <InboxIcon className='size-5'/>
                            <p className='text-center break-words max-w-[292px]'>
                                No Transactions
                            </p>
                        </div>
                    </TabsContent>
                    <TabsContent value="settings" className="">
                        Settings
                    </TabsContent>
                </Tabs>

            </NonModalWindow.Body>
            <NonModalWindow.Footer>
                <Button
                    type="submit"
                >
                    <ButtonText>
                        Add Transaction
                    </ButtonText>
                </Button>
            </NonModalWindow.Footer>
        </NonModalWindow>
    )
}
